import { axios, toCamelCase, toSnakeCase } from '@utils';

const BASE_URL = '/api/v1/legup/profile_editor';

async function updateCenterProfile(data, centerId) {
  const { facilityId } = data;
  const response = await axios.put(BASE_URL, {
    child_care_facility_id: facilityId,
    center_id: centerId,
    section_name: data.sectionName,
    profile_data: toSnakeCase(data),
  });
  return toCamelCase(response);
}

async function saveDocuments(data) {
  const { centerId, documents } = data;
  const formData = new FormData();
  formData.append('center_id', centerId);

  documents.filter((doc) => doc.isNew || doc.removed || doc.updated).forEach((doc, index) => {
    if (doc.selectedFile && doc.isNew) {
      formData.append(`profile_data[documents][${index}][file]`, doc.selectedFile);
    }
    formData.append(`profile_data[documents][${index}][display_name]`, doc.displayName || '');
    if (doc.providerFileId) {
      formData.append(`profile_data[documents][${index}][provider_file_id]`, doc.providerFileId);
    }
    if (doc.url) {
      formData.append(`profile_data[documents][${index}][url]`, doc.url);
    }
    if (doc.includeIn && doc.includeIn.length > 0) {
      doc.includeIn.forEach((item, itemIndex) => {
        formData.append(`profile_data[documents][${index}][include_in][${itemIndex}]`, item);
      });
    }

    if (doc.removed) {
      formData.append(`profile_data[documents][${index}][remove]`, true);
    }
  });
  const response = await axios.post(`${BASE_URL}/save_documents`, formData);
  return toCamelCase(response);
}

async function fetchSubsidies(centerId) {
  try {
    const { data } = await axios.get(`/api/v1/legup/centers/${centerId}/subsidies`);
    return toCamelCase(data);
  } catch (error) {
    throw new Error(error);
  }
}

async function fetchScheduleTypes() {
  const response = await axios.get('/api/v1/schedule_types.json');
  return response.data;
}

async function fetchPhilosophies() {
  const response = await axios.get('/facility_philosophies.json');
  return response.data;
}

async function updateProviderInfo(data) {
  const response = await axios.post(`${BASE_URL}/update_provider_info`, toSnakeCase(data));
  return toCamelCase(response.data);
}

export {
  updateCenterProfile, saveDocuments, fetchSubsidies,
  fetchScheduleTypes, fetchPhilosophies, updateProviderInfo,
};
